import BlockIcon from '@mui/icons-material/Block';
import { Badge } from '@mui/material';
import { PickersDay, PickersDayProps } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';
import { FC } from 'react';
import { DATE_TIME_DAY_FORMAT } from '../../helpers/time';
import { MonthlyAvailability } from '../../lib/scheduling/types';
import { StyledTheme } from '../../theme';

type Props = PickersDayProps<string> & {
  monthlyAvailability?: MonthlyAvailability | null;
};

const CalendarDay: FC<Props> = ({ day, monthlyAvailability, outsideCurrentMonth, ...other }) => {
  const yyyyMMddDay = (day as unknown as DateTime).toFormat(DATE_TIME_DAY_FORMAT);

  const slot = monthlyAvailability?.dates.find((d) => d.date === yyyyMMddDay);
  const shouldShowAsBlocked =
    !!!slot?.allowed && (slot?.issues.length || 0) > 0 && !outsideCurrentMonth;

  return (
    <Badge
      key={day.toString()}
      overlap='rectangular'
      badgeContent={
        shouldShowAsBlocked && (
          <BlockIcon
            sx={{
              color: StyledTheme.colors.curiousBlue,
              height: 12,
              width: 12,
            }}
          />
        )
      }>
      <PickersDay
        {...other}
        day={day}
        outsideCurrentMonth={outsideCurrentMonth}
        sx={{
          '&.Mui-selected': {
            backgroundColor: StyledTheme.colors.curiousBlue,
            borderColor: StyledTheme.colors.curiousBlue,
            color: 'white',
          },
        }}
      />
    </Badge>
  );
};

export default CalendarDay;
